import { CircleAlert } from "lucide-react";
import { AttachmentCardShell } from "../AttachmentCardShell/AttachmentCardShell.js";

export function MessageUnsupported({
  label,
}: {
  label: string;
}): React.JSX.Element {
  return (
    <AttachmentCardShell className="max-w-[18rem]">
      <CircleAlert className="size-5 shrink-0 text-ink-subtle" aria-hidden="true" />
      <p className="m-0 text-[0.8125rem] leading-snug text-ink">{label}</p>
    </AttachmentCardShell>
  );
}
